import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  constructor(
    private http: HttpClient,
  ) { }

  /**
   * Récupère une vidéo en tant que Blob pour streaming
   * @param jobId - ID du job
   * @returns Observable<Blob> - La vidéo sous forme de Blob
   */
  getVideoFinalStream(jobId: number): Observable<Blob> {
    const url: string = `${environment.apiUrl}/jobs/${jobId}/final`;

    const headers = new HttpHeaders({
      'Accept': 'video/mp4'
    });

    return this.http.get(url, {
      responseType: 'blob',
      headers: headers
    }).pipe(
      catchError(error => {
        console.error('Erreur lors du chargement de la vidéo:', error);
        return throwError(() => error);
      })
    );
  }

  /**
   * Récupère une vidéo avec progress tracking
   * @param jobId - ID du job
   * @returns Observable<HttpEvent<Blob>> - Events de progression
   */
  getVideoWithProgress(jobId: number): Observable<HttpEvent<Blob>> {
    const url: string = `${environment.apiUrl}/jobs/${jobId}/final`;
    return this.http.get(url, {
      responseType: 'blob',
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(error => {
        console.error('Erreur lors du chargement avec progress:', error);
        return throwError(() => error);
      })
    );
  }

  downloadAsset(jobId: number, asset: string): Observable<HttpEvent<Blob>> {
    const url: string = `${environment.apiUrl}/script/assets/${jobId}/${asset}`;
    return this.http.get(url, {
      responseType: 'blob' as 'blob',
      observe: 'events'
    })
  }
}